const API_BASE_URL = 'https://admin.dh.mindflares.net/api';

export async function fetchProperties(signal) {
  const response = await fetch(`${API_BASE_URL}/properties`, { signal });

  if (!response.ok) {
    throw new Error('Failed to load properties');
  }

  return response.json();
}

export async function fetchPropertiesByCategory(categoryId, signal) {
  const response = await fetch(
    `${API_BASE_URL}/propertyByCategory?categoryId=${categoryId}`,
    { signal }
  );

  if (!response.ok) {
    throw new Error('Failed to load properties by category');
  }

  return response.json();
}

export async function fetchPropertyById(id, signal) {
  const response = await fetch(`${API_BASE_URL}/propertyById?id=${id}`, {
    signal
  });

  if (!response.ok) {
    throw new Error('Failed to load property');
  }

  return response.json();
}

export async function fetchSimilarProperties(id, signal) {
  const response = await fetch(`${API_BASE_URL}/properties/${id}/similar`, {
    signal
  });

  if (!response.ok) {
    throw new Error('Failed to load similar properties');
  }

  return response.json();
}
